import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const ColorPricesPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [price, setPrice] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setPrice(props.price);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setPrice(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "colorPrices", props.id);
      await updateDoc(ref, {
         price: price,
      })
         .then(() => {
            setIsModalOpen(true);
            setPrice(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title={"Price for :" + props.title} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Price :" value={price} style={{ width: "100%" }} onChange={(value) => setPrice(value)} />
            </Space>
         </Modal>
      </>
   );
};
